import React, { useCallback, useEffect } from "react";

export const useMouseOutside = (
  containerRef: React.RefObject<HTMLElement>,
  eventAction: (e: MouseEvent | TouchEvent) => void,
  eventType: "click" | "mousedown" = "mousedown"
) => {
  const handler = useCallback(
    (e: MouseEvent) => {
      if (e.type === eventType) {
        const el = containerRef.current;
        if (el && e.target && !el.contains(e.target as Node)) {
          eventAction(e);
        }
      }
    },
    [containerRef, eventAction, eventType]
  );

  useEffect(() => {
    document.addEventListener(eventType, handler, true);
    return () => {
      document.removeEventListener(eventType, handler, true);
    };
  }, [eventType, handler]);
};

export default useMouseOutside;
